// extracted by mini-css-extract-plugin
export var cardIcon = "_9j-4";
export var checkboxCard = "_9j-0";
export var checkboxCardSelected = "_9j-3";
export var disabled = "_9j-1";
export var outerBorder = "_9j-2";
export var spacerMedium = "_9j-7";
export var spacerSmall = "_9j-6";
export var spacerXsmall = "_9j-5";